import type { FC } from 'react';

import { ButtonAction } from 'components/button/ButtonAction';
import { Modal, closeModal, formatDate } from 'enable-ui';

import { MODAL_KEY } from 'modules/auth/core/modal-key';

import type { EventCalendar } from '../core/type';

import { LessonInfoComp } from './LessonInfoComp';

export const LessonInfoModal: FC<{
  goToDetailPage: () => void;
  handleDuplicate: () => void;
  handleDelete: () => void;
  value: EventCalendar;
  handleUpdateEvent: () => void;
  handleChangeValue: (value: Date, startTime: string, endTime: string) => void;
}> = ({
  goToDetailPage,
  handleDelete,
  handleDuplicate,
  value,
  handleUpdateEvent,
  handleChangeValue,
}) => {
  const startDate = (value?.start ? new Date(value.start) : '') as Date;

  const endDate = (value?.end ? new Date(value.end) : '') as Date;

  const startTime = formatDate(startDate, 'HH:mm');

  const endTime = formatDate(endDate, 'HH:mm');

  const disabledSubmitButton = startTime === endTime || startTime > endTime;

  return (
    <Modal
      modalKey={MODAL_KEY.LESSON_INFO}
      hideCloseIcon
      onSubmit={handleUpdateEvent}
      size="lg"
      footer={
        <ButtonAction
          disabledCancel={false}
          disabledSubmit={disabledSubmitButton}
          titleCancel="Cancel"
          titleSubmit="Submit"
          style={{ justifyContent: 'end', padding: '0px 40px 24px 0px' }}
          onSubmit={handleUpdateEvent}
          onCancel={() => closeModal(MODAL_KEY.LESSON_INFO)}
        />
      }
    >
      <LessonInfoComp
        goToDetailPage={goToDetailPage}
        handleDuplicate={handleDuplicate}
        handleDelete={handleDelete}
        value={value}
        handleChangeValue={handleChangeValue}
      />
    </Modal>
  );
};
